export function limitDecimalPlaces(number: string, maxDecimals = 18) {
  let [intPart, decPart = ""] = Number(number).toFixed(100).split(".")

  decPart = decPart.slice(0, maxDecimals)

  decPart = decPart.replace(/0+$/, "")

  return decPart ? `${intPart}.${decPart}` : intPart
}
